import React from 'react';

import {useParams} from 'views/module';

import {EventFeedbackInput, EventFeedbackThankYou} from 'views/scenes/event_feedback';

const Profile = (props) => {
  const params = useParams();
  const [isFeedbackSent, setIsFeedbackSent] = React.useState(false);

  if (!isFeedbackSent) {
    return (
      <>
        <EventFeedbackInput
          eventFeedbackRn={params.eventFeedbackRn}
          setIsFeedbackSent={setIsFeedbackSent}
        />
      </>
    );
  } else {
    return <EventFeedbackThankYou />;
  }
};

Profile.propTypes = {
};

export default React.memo(Profile);

